import { render } from "./humanNav.vue?vue&type=template&id=f08ccb22"
import script from "./humanNav.vue?vue&type=script&lang=js"
export * from "./humanNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__